__turbopack_context__.v({
  "dark": "ParagraphBenefitsTools-module__FcWsBq__dark",
  "darkHead": "ParagraphBenefitsTools-module__FcWsBq__darkHead",
  "darkIntro": "ParagraphBenefitsTools-module__FcWsBq__darkIntro",
  "darkTitle": "ParagraphBenefitsTools-module__FcWsBq__darkTitle",
  "darkWrap": "ParagraphBenefitsTools-module__FcWsBq__darkWrap",
  "eyebrow": "ParagraphBenefitsTools-module__FcWsBq__eyebrow",
  "footerNote": "ParagraphBenefitsTools-module__FcWsBq__footerNote",
  "lead": "ParagraphBenefitsTools-module__FcWsBq__lead",
  "metricBody": "ParagraphBenefitsTools-module__FcWsBq__metricBody",
  "metricCard": "ParagraphBenefitsTools-module__FcWsBq__metricCard",
  "metricDesc": "ParagraphBenefitsTools-module__FcWsBq__metricDesc",
  "metricName": "ParagraphBenefitsTools-module__FcWsBq__metricName",
  "metricPill": "ParagraphBenefitsTools-module__FcWsBq__metricPill",
  "metrics": "ParagraphBenefitsTools-module__FcWsBq__metrics",
  "section": "ParagraphBenefitsTools-module__FcWsBq__section",
  "title": "ParagraphBenefitsTools-module__FcWsBq__title",
  "toolBadge": "ParagraphBenefitsTools-module__FcWsBq__toolBadge",
  "toolCard": "ParagraphBenefitsTools-module__FcWsBq__toolCard",
  "toolDesc": "ParagraphBenefitsTools-module__FcWsBq__toolDesc",
  "toolName": "ParagraphBenefitsTools-module__FcWsBq__toolName",
  "tools": "ParagraphBenefitsTools-module__FcWsBq__tools",
  "top": "ParagraphBenefitsTools-module__FcWsBq__top",
  "topLeft": "ParagraphBenefitsTools-module__FcWsBq__topLeft",
});
